import { render, staticRenderFns } from "./CardCheck.vue?vue&type=template&id=dcd60b56&scoped=true&"
import script from "./CardCheck.vue?vue&type=script&lang=js&"
export * from "./CardCheck.vue?vue&type=script&lang=js&"
import style0 from "./CardCheck.vue?vue&type=style&index=0&id=dcd60b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd60b56",
  null
  
)

export default component.exports